import React from "react";
import { motion } from "framer-motion";
import { HomeIcon, ShieldIcon, WindIcon, CalendarHeartIcon, BoxIcon } from "lucide-react";
interface Route {
  icon: BoxIcon;
  title: string;
  description: string;
}
const routes: Route[] = [{
  icon: HomeIcon,
  title: 'Quiero renovar mi espacio',
  description: 'Encontrá una práctica de limpieza energética del hogar para crear un momento de intención y armonía.'
}, {
  icon: ShieldIcon,
  title: 'Quiero proteger mi energía',
  description: 'Accedé a un ritual guiado para fortalecer límites y volver a tu centro.'
}, {
  icon: WindIcon,
  title: 'Necesito una pausa consciente',
  description: 'Usá ejercicios breves de respiración y afirmaciones para bajar el ritmo y recuperar presencia.'
}, {
  icon: CalendarHeartIcon,
  title: 'Quiero sostener una práctica',
  description: 'Organizá tus intenciones con el planificador, el calendario lunar y el diario de bienestar.'
}];
export function StartRoutes() {
  return <section className="w-full bg-lavender px-5 py-12 sm:py-16" data-id="element-159" data-mp="31s0i2a66l4u8">
      <div className="mx-auto max-w-6xl" data-id="element-160" data-mp="ey336x41aq3q">
        <h2 className="mx-auto max-w-2xl text-center font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-161" data-mp="jvmuaxltyxd3">
          No necesitás hacer todo. Solo elegir qué querés acompañar hoy.
        </h2>

        <div className="mt-9 grid gap-4 sm:gap-5 md:grid-cols-2 lg:grid-cols-4" data-id="element-162" data-mp="tubzpqwjipcg">
          {routes.map((route, i) => {
          const Icon = route.icon;
          return <motion.article key={route.title} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.3,
            delay: i * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-2xl border border-aura/15 bg-card p-6" data-id="element-163" data-mp="xtbcfxoijqeg" data-mpi={i}>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-aura/10 text-aura" data-id="element-164" data-mp="1lm0awa3l15tp">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-165" data-mp="3ime9f9nv32f8" />
                </span>
                <h3 className="mt-4 text-base font-bold leading-snug text-plum sm:text-lg" data-id="element-166" data-mp="3dnks165ger9s">
                  {route.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-plum/75" data-id="element-167" data-mp="3rfr9qwo996bc">
                  {route.description}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-168" data-mp="58t1e1wss6ui">
          <a href="#incluye" className="inline-flex min-h-[48px] items-center justify-center rounded-[10px] border border-aura bg-card px-6 py-3 text-[13px] font-bold text-aura transition-colors duration-150 ease-out hover:bg-aura hover:text-white sm:text-sm" data-id="element-169" data-mp="8eq8azwggs9">
            VER TODO LO QUE INCLUYE
          </a>
        </div>
      </div>
    </section>;
}